import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OtherProfileData } from "@src/constants";

export interface ConsentInfo {
    status: string;
    version_current: boolean;
}

export interface UserConsents {
    AI_USAGE?: ConsentInfo;
    ORG_AI_USAGE?: ConsentInfo;
    [key: string]: ConsentInfo | undefined;
}

export interface UserProfile {
    first_name: string;
    last_name: string;
    email: string;
    gender: string;
    age: number | string | null;
    npi: string | null;
    license: string | null;
    license_state: string | null;
    specialty: string | null;
    credentials: string | null;
    country: string | null;
    updated_at: string | null;
    is_doctor: boolean;
    is_beta_tester: boolean;
    is_demo?: boolean;
    demographics: OtherProfileData;
    consents?: UserConsents;
}

interface UserProfileState {
    loading: boolean;
    error: string | null;
    data: UserProfile | null;
}

const initialState: UserProfileState = {
    loading: false,
    error: null,
    data: null,
};

const userProfileSlice = createSlice({
    name: "userProfile",
    initialState,
    reducers: {
        fetchUserProfileRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchUserProfileSuccess: (state, action: PayloadAction<UserProfile>) => {
            state.loading = false;
            state.data = action.payload;
        },
        fetchUserProfileFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
        clearUserProfileData: (state) => {
            state.data = null;
        },
    },
});

export const { fetchUserProfileRequest, fetchUserProfileSuccess, fetchUserProfileFailure, clearUserProfileData } =
    userProfileSlice.actions;

export const userProfileReducer = userProfileSlice.reducer;
export const userProfileActionTypes = userProfileSlice.actions;
